export const backgroundPopupColor = [
  {
    name: "backgroundColor",
    type: "string",
    enum: ["white", "black", "softBlack", "blurredWhite", "blurredBlack", "blurredSoftBlack"],
    required: true,
    defaultValue: "blurredWhite",
  },
] as const satisfies Inputs;
